import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FLYOUT_KEY = 'RATINGS_AND_REVIEWS_FLYOUT';

export const useReviewsFlyoutStateManager = () => {
  return useOpenedStateManager(FLYOUT_KEY);
};
